import React, { useState, useEffect } from "react";
import "./HomeContent.css";
import DimensionLearningData from "../data/DimensionLearningData.json";
import CurrentHighlightsData from "../data/CurrentHighlightsData.json";
import AtcClusterData from "../data/AtcClusterData.json";
import TestimonialContent from "../function-components/TestimonialContent";
import Modal from "react-modal";
import CurrentHighlightsNew from "../function-components/CurrentHighlightsNew";
import { Link } from "react-router-dom";

function HomeContent() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem("hasSeenTestimonialPopup");
    if (!hasSeenPopup) {
      setIsModalOpen(true);
      sessionStorage.setItem("hasSeenTestimonialPopup", "true");
    }
  }, []);
  return (
    <>
      <div className="main-banner">
        <img
          src="images/Home/banner-home.png"
          alt="banner"
          className="banner-img"
        />
      </div>
      {/* first section */}
      <div className="aboutus_wrap">
        <div className="aboutus_container">
          <div>
            <div className="home-box">
              <h2 className="main-headings">About Us</h2>
            </div>
            <div>
              <p className="aboutus_para">
                The ATC GN Learning team is dedicated to providing exceptional
                learning experiences and training programs to the employees for
                all ATCs. The team focuses on addressing learning needs across
                various regions globally including AMERICAS, APAC, EMEA, and
                Philippines for a comprehensive range of training programs from
                Technology, Delivery to Professional Skills by leveraging the
                scale and expertise of Learning & Talent Transformation (L&TT)
                team at ATCI.
                {/* ATCGN is part of Learning & Talent Transformation (L&TT) at ATC-I dedicated to deliver exceptional learning experiences and training programs to employees at the Advanced Technology Centers Global. */}
              </p>
            </div>
          </div>
          <div>
            <img
              src="images/Home/aboutus_img.png"
              alt="aboutus"
              className="aboutus-img"
            />
          </div>
        </div>
      </div>
      {/* second section */}
      <div className="dimension-container" id="DimensionofLearning">
        <div className="dimension_section">
          <div className="home-box">
            <h2 className="main-headings">Dimensions of Learning</h2>
          </div>
          <p className="sub-text">
            Accenture's ATCGN team offers a comprehensive range of training
            programs designed to enhance various skills and competencies. Here
            are some details about the different types of training they provide:
          </p>
          <div className="dimension_box">
            {DimensionLearningData.map((item, i) => (
              <div className="dimension_box_innerwrap">
                <div className="dimension_box_innerhold">
                  <img src={item.img} alt="cards" className="dimension_cards" />
                  <div className="dimension_anchor">
                    <a href={item.link1} target="_blank">
                      {item.explore}
                    </a>
                    <img
                      src="images/Home/arrow_icon.png"
                      alt="icon"
                      className="arrow_img"
                    />
                  </div>

                  <div className="dimension_text_area">
                    <h3>{item.name}</h3>
                    <p>{item.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* third section */}
      <div className="current_highlights_container">
        <div className="home-box">
          <h2 className="main-headings">Current Initiatives across GN</h2>
        </div>
        <div className="current_highlights_innersec">
          <CurrentHighlightsNew />
        </div>
      </div>
      {/* forth section */}
      <div className="cluster_container">
        <div className="home-box">
          <h2 className="main-headings">ATC Clusters</h2>
        </div>
        <div className="cluster_section">
          {AtcClusterData.map((item, i) => (
            <div className="cluster-section-row">
              <Link to={item.link} className="cluster-link">
                <div key={item.id} className="cluster-section-box">
                  <img src={item.img} alt="cluster" className="cluster-img" />
                  <h3>{item.name}</h3>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
      {/* fifth section */}
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        contentLabel="Testimonials"
        className="testimonial-modal"
        overlayClassName="testimonial-overlay"
      >
        <button className="close-btn-modal" onClick={() => setIsModalOpen(false)}>
          &times;
        </button>
        <div className="testimonial-sec-container">
          <div className="testimonial-sec-wrap">
            <h2 className="main-headings">ATCGN Testimonials</h2>
            <TestimonialContent />
          </div>
        </div>
      </Modal>

    </>
  );
}

export default HomeContent;
